'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { X } from 'lucide-react';
import { useState } from 'react';
import { client } from '../../../utils/trpc';
import Avatar from '../../common/Avatar';
import Input from '../../UI/Input';
import { t } from './parts';
type Props = {
  value: string;
  onChange: (spaceSlug: string) => void;
};

/** Typeahead over the spaces you moderate. Focus opens the list before you
 *  type, so the picker also answers "which spaces can I even post this to?". */
const SpacePicker = t0 => {
  const $ = _c(35);
  const {
    value,
    onChange
  } = t0;
  const [search, setSearch] = useState("");
  const [focused, setFocused] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: ["userModeratedSpaces"],
      queryFn: _temp,
      staleTime: 60000
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: userSpaces
  } = useQuery(t1);
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[1] !== focused || $[2] !== onChange || $[3] !== search || $[4] !== userSpaces?.spaces || $[5] !== value) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const spaces = userSpaces?.spaces ?? [];
      let t8;
      if ($[12] !== value) {
        t8 = space => space.spaceSlug === value;
        $[12] = value;
        $[13] = t8;
      } else {
        t8 = $[13];
      }
      const selected = spaces.find(t8);
      const query = search.trim().toLowerCase();
      const matches = spaces.filter(space_0 => !query || space_0.name.toLowerCase().includes(query) || space_0.spaceSlug.toLowerCase().includes(query));
      if (selected) {
        let t9;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t9 = <label className={t.label}>Space</label>;
          $[14] = t9;
        } else {
          t9 = $[14];
        }
        let t10;
        if ($[15] !== onChange) {
          t10 = () => {
            onChange("");
            setSearch("");
          };
          $[15] = onChange;
          $[16] = t10;
        } else {
          t10 = $[16];
        }
        let t11;
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
          t11 = <X size={14} />;
          $[17] = t11;
        } else {
          t11 = $[17];
        }
        let t12;
        if ($[18] !== t10) {
          t12 = <button type="button" onClick={t10} className="shrink-0 rounded-md p-1 text-textSecondary transition-colors hover:bg-ds-border-standard hover:text-textPrimary" title="Clear space">{t11}</button>;
          $[18] = t10;
          $[19] = t12;
        } else {
          t12 = $[19];
        }
        const t13 = <div className="flex items-center gap-2.5 rounded-lg border border-ds-border-standard px-2.5 py-1.5"><Avatar spaceAvatarKey={selected.avatarKey} size={24} /><div className="min-w-0 flex-1"><p className={`truncate ${t.label}`}>{selected.name}</p><p className={`truncate ${t.meta}`}>s/{selected.spaceSlug}</p></div>{t12}</div>;
        let t14;
        if ($[20] !== t13) {
          t14 = <div className="space-y-1">{t9}{t13}</div>;
          $[20] = t13;
          $[21] = t14;
        } else {
          t14 = $[21];
        }
        t7 = t14;
        break bb0;
      }
      t5 = "space-y-1";
      if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <label className={t.label}>Space <span className="font-normal text-textSecondary">(optional)</span></label>;
        $[22] = t6;
      } else {
        t6 = $[22];
      }
      t2 = "relative";
      let t10;
      let t9;
      if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = () => setFocused(true);
        t10 = async () => setFocused(false);
        $[23] = t10;
        $[24] = t9;
      } else {
        t10 = $[23];
        t9 = $[24];
      }
      if ($[25] !== search) {
        t3 = <Input type="search" label="Search your spaces" inputClassName="text-sm" value={search} onChange={setSearch} onFocus={t9} onBlur={t10} />;
        $[25] = search;
        $[26] = t3;
      } else {
        t3 = $[26];
      }
      t4 = (focused || search.trim()) && <div className="absolute z-20 mt-1 w-full overflow-hidden rounded-lg border border-ds-border-standard bg-background-secondary shadow-xl">{matches.length === 0 ? <p className={`px-3 py-3 text-center ${t.meta}`}>{search.trim() ? "No spaces you moderate match." : "You don't moderate any spaces yet."}</p> : <div className="max-h-56 overflow-auto p-1">{matches.map(space_1 => <button key={space_1.id} type="button" onMouseDown={_temp2} onClick={() => {
            onChange(space_1.spaceSlug);
            setSearch("");
            setFocused(false);
          }} className="flex w-full items-center gap-2.5 rounded-md px-2 py-1.5 text-left transition-colors hover:bg-ds-border-standard"><Avatar spaceAvatarKey={space_1.avatarKey} size={24} /><div className="min-w-0 flex-1"><p className={`truncate ${t.label}`}>{space_1.name}</p><p className={`truncate ${t.meta}`}>s/{space_1.spaceSlug}</p></div></button>)}</div>}</div>;
    }
    $[1] = focused;
    $[2] = onChange;
    $[3] = search;
    $[4] = userSpaces?.spaces;
    $[5] = value;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[27] !== t2 || $[28] !== t3 || $[29] !== t4) {
    t8 = <div className={t2}>{t3}{t4}</div>;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== t5 || $[32] !== t6 || $[33] !== t8) {
    t9 = <div className={t5}>{t6}{t8}</div>;
    $[31] = t5;
    $[32] = t6;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  return t9;
};
export default SpacePicker;
function _temp() {
  return unwrapFromResult(client.spaces.myModerated.query());
}
function _temp2(e) {
  return e.preventDefault();
}